<template>
    <div class="aipage">
      <extraPage :content="content"></extraPage>
    </div>
</template>
<script>
import extraPage from '@/components/extraPage.vue'
/* eslint-disable */
export default {
    components: {
        extraPage,
    },
    data() {
        return {
          content:{
            bannerTitle: require("@/assets/images/bussiness/iaas/iaasTitle.png"),
            bannerSmallTitle: '软硬一体，开箱即用；多模融合，智能驱动；本地专属，安全可控；国产适配，自主未来——为AI落地提供全栈解决方案',
            productOverviewContent: '智创一体机搭载我司自研企业级AI大模型智创平台，预置DeepSeek / Qwen/ Llama等主流LLM大模型、多模态模型、语音模型和视觉模型等，采用软硬件一体化设计，提供“算力+平台+AI应用”的一站式解决方案，为用户提供快速交付、开箱即用、极致性能、安全高效的全栈大模型微调和推理的开发能力，加快DeepSeek等大模型在各行业的应用落地速度',
            productOverviewImg: require("@/assets/images/bussiness/iaas/paas_wrapbg1.png"),
            productArchitectureImg2: require("@/assets/images/bussiness/iaas/paas_wrapbg2.png"),
            aiContentList: [
                { title: '工业制造', wrapPic: require("@/assets/images/bussiness/iaas/wrapbg1.png"), content:'赋能设备预测性维护、工艺优化与智能质检，提升生产效能。' },
                { title: '政务民生', wrapPic: require("@/assets/images/bussiness/iaas/wrapbg2.png"), content:'本地化部署保障数据安全，支撑智能审批、城市管理等公共服务。' },
                { title: '医疗健康', wrapPic: require("@/assets/images/bussiness/iaas/wrapbg3.png"), content:'私有化医疗大模型助力辅助诊疗、影像分析与科研加速。' },
                { title: '教育科研', wrapPic: require("@/assets/images/bussiness/iaas/wrapbg4.png"), content:'提供个性化教学工具与本地化算力，支持教育创新与学术研究。' },
            ],
            productGoodsList: [
                { title: '一体化交付与高效开发', wrapPic: require("@/assets/images/bussiness/iaas/wrapbg5.png"), content:'提供软硬一体化的开箱即用解决方案，内置主流计算框架和开发工具链，支持从数据处理、模型精调到一键部署的全流程，降低技术门槛并兼容自研模型。' },
                { title: '多模态模型与智能体生态', wrapPic: require("@/assets/images/bussiness/iaas/wrapbg6.png"), content:'集成文本、语音、视觉等多类预训练模型，覆盖企业知识库、智能写作、工业预测等场景，提供即插即用的AI智能体应用支持。' },
                { title: '本地化安全部署', wrapPic: require("@/assets/images/bussiness/iaas/wrapbg7.png"), content:'通过数据本地化存储、分级加密及多级审核机制，确保企业数据全链路安全可控，满足隐私保护和合规需求。' },
                { title: '国产化自主可控', wrapPic: require("@/assets/images/bussiness/iaas/wrapbg8.png"), content:'全面适配国产芯片、服务器及操作系统，构建从硬件到软件的自主技术栈，保障供应链安全与合规性。' },
            ],
            // productCapacityList:[
              
            // ],
            // caseList: [
            // ]
          }
      }
    },
}
</script>